<template>
  <VWidget
    :title="$t('Conditions')"
    class="mb-4"
  >
    <div slot="widget-content">
      <query-builder
        :operators="operators"
        :operands="operands"
        :max-depth="2"
        :_query.sync="item.condition"
      />
    </div>
  </VWidget>
</template>

<script>
import QueryBuilder from '../../../Rules/components/QueryBuilder'
import rules from '../../rules'

export default {
  name: 'DiscountSingleConditions',

  components: {
    QueryBuilder
  },

  props: {
    item: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      types: rules.types,
      operators: rules.operators,
      operands: rules.operands
    }
  }
}
</script>
